module.exports = __webpack_public_path__ + "img/book.bac57e88.jpg";